import O1HD from "../../../../engines/gameEngine";
import data_control from "../../../../engines/libs/data_control";
import { BUNDLE_SMALL_NAME, getOneBundleOnePrefab } from "../../BundleResourceConfig";
import NormalGameManager from "../../manager/NormalGameManager";
import { loveStoryEvent } from "./loveStoryConst";
import loveStoryItem from "./loveStoryItem";
import backpackOpenBase from "../backpackOpenBase";

const {ccclass, property} = cc._decorator;

@ccclass
export default class loveStoryPrefab extends backpackOpenBase {

    onBackPackOpenPrefab(...arg: any[]) {
        super.onBackPackOpenPrefab(arg[0]);
    }

    @property({type:cc.Prefab,displayName:"peopleItem"})
    peopleItem:cc.Prefab = null;

    @property({type:cc.Node,displayName:"itemContent"})
    itemContent:cc.Node = null;

    @property({type:cc.Label,displayName:"全部钱文本"})
    lb_TotalCoin:cc.Label = null;

    @property({type:cc.Label,displayName:"分享卡数量"})
    shareCardCount : cc.Label = null;

    onLoad(){
        O1HD.on(loveStoryEvent.UPDATE_LOVESTORYPREFAB,this.loadItems,this);
        O1HD.on("refreshShareCount" , this.refreshShareCardCount , this );
    }

    start(){
        this.loadItems();
    }

    loadItems(){
        let peoples = NormalGameManager._instance.loveStroyManager.getData().poeple;

        let length = Object.keys(peoples).length + 1;
        let needCount:number = length - this.itemContent.childrenCount;
        // let needCount = 3;
        if( needCount > 0 ){
            for(let i = 0; i<needCount; i++){
                let item:cc.Node = cc.instantiate(this.peopleItem);
                item.getComponent(loveStoryItem).registerParentScript( this );
                item.setParent(this.itemContent);
            }
        }else{
            for(let i = needCount; i<0; i++){
                this.itemContent.children[this.itemContent.childrenCount - Math.abs(i)].active = false;
            }
        }
        this.updatePrefab();
    }

    async onBtnShare(){
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        if ( !NormalGameManager._instance.getGameData().backpack[11116] || NormalGameManager._instance.getGameData().backpack[11116].num <= 0 ) {
            O1HD.getModules().uiControlModule.showMessageBox("请先去漂流瓶捞取邀请卡");
            return ;
        }

        let url:string = `prefab/loveStroySharePrefab`;
        let prefab = await getOneBundleOnePrefab(BUNDLE_SMALL_NAME.loveStroyGameBundle,url);
        if(prefab){
            let node:cc.Node = cc.instantiate(prefab);
            node.setParent(O1HD.Canvas());
        }else{
            O1HD.getModules().uiControlModule.showMessageBox("加载失败~请重启游戏或者换台设备试试");
        }
    }

    updatePrefab(){
        let peoples = NormalGameManager._instance.loveStroyManager.getData().poeple;
        let coins:number = 0;
        let index = 0;
        for(let k in peoples){
            let p = peoples[k];
            coins += (p.totalCoin);
            this.itemContent.children[index].getComponent(loveStoryItem).bindData(p);
            this.itemContent.children[index].active = true;
            index ++;
        }
        this.lb_TotalCoin.string = data_control.getNumberFormat(coins);
        //刷新分享卡牌
        this.refreshShareCardCount();
    }

    /**
     * 刷新分享卡牌
     */
    refreshShareCardCount () {
        if ( this.node ) {
            let backpackI = NormalGameManager._instance.getGameData().backpack[11116];
            this.shareCardCount.string = `邀请卡x${ backpackI ? backpackI.num : 0 }`;
        }
    }

    onBtnBack(){
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        this.node.destroy();
        this.node.removeFromParent();
    }

}
